import React, { useReducer, createContext } from "react";
import Cookies from 'js-cookie'
export const PropertyContext = createContext();

const initialState = {
    Pictures: [],
    RegisterDate: '', //تاریخ ثبت
    ExpireDate: '', // تاریخ بازیابی
    Row: '', //کد ملک
    FullName: '',//نام مالک
    Mobile: '',//شماره همراه
    Phone: '',//تلفن
    CurrentResidentPhoneNumber: '',//تلفن ساکن فعلی
    PropertyType: "",
    PropertyArea: "",//محدوده
    Address: "",//آدرس,
    Latitude: "",
    Longitude: "",
    Infrastructure: "",//زیربنا
    Space: "",//مساحت
    SalePriceCalcMode: '1', //نوع محاسبه قیمت
    RoomsCount: "",//تعداد اتاق
    StoreyNo: "",//طبقه
    StoreyCount: "",//تعداد طبقه
    UnitsCount: "",//تعداد واحد در طبقه
    LoanPrice: "",//میزان وام ملک
    UsageType: [],//نوع کابری
    Facilities: [],//امکانات 
    Water: "",//
    Electricity: "",//
    Gas: "",//
    PropertyAge: "",//سال ساخت
    EstateStatus: "",//وضعیت بنا
    Aggregation: "",//تراکم
    CertificateType: "",//نوع سند
    Direction: "",//جهت
    Frontage: "",//نما
    Floor: "",//کفپوش
    Heating: [],//گرمایش
    Cooling: [],//سرمایش
    KitchenService: "",//سرویس اشپزخانه
    SalePrice: "",//قیمت فروش
    MortgagePrice1: "",//قیمت رهن
    RentPrice1: "",//قیمت اجاره
    PreSalePrice: "",//مبلغ کل پیش فروش
    PrePayPrice: "",//مبلغ پیش پرداخت
    ForExchange: "",//0,1 معاوضه
    ForAssociate: "",//0,1 مشارکت
    PublicDescription: "",//توضیحات عمومی
    Description: "",//توضیحات خصوصی
    //ویژگی های اصلی
    Court: "0",// حیاط
    Parking: "0",// پارگینگ
    Elevator: "0",// آسانسور
    Elec3Phase: "0",// برق سه فاز
    Store: "0",// انباری
    InputSeparate: "0",//0,1 دارای ورودی جداگانه
    CommercialMeter: "0",//مترژ تجاری
    Deadlock: "0",//0,1 کوچه بن بست
    //end
    RentPrefer: [],// لیستی از ارجهیت های اجارها
    Floors: [],
    LocationId: Cookies.get('locationId'),
    AgencyId: Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id,
    RegistrarDevice: 8,
    IsConfirmed: "1",
    Prefix: Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id
};

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD_PICTURES":

            return {
                ...state,
                Pictures: [...state.Pictures, action.payload[1]]
            };
        case "REMOVE_PICTURES":
            console.log("action.payload.name", action.payload.name)
            const tmpPic = state.Pictures.filter(item => item != action.payload.name)
            return {
                ...state,
                Pictures: tmpPic
            };
        case "UPDATE_STATE":
            console.log('action.payload.name', action.payload.name)
            // console.log('action.payload.value',action.payload.value)
            if (state[action.payload.name] != null) {
                var typeOfVar = typeof state[action.payload.name]

                console.log(typeOfVar)

                if (typeOfVar == "object") {
                    const isArray = Array.isArray(state[action.payload.name])
                    if (isArray) {
                        console.log("action.payload.value", action.payload.value)
                        if (!action.payload.append) {
                            if (state[action.payload.name].includes(action.payload.value)) {
                                const index = state[action.payload.name].indexOf(action.payload.value);
                                const newItem = state[action.payload.name].filter((item, index) => item != action.payload.value);
                                console.log(newItem)
                                return {
                                    ...state, [action.payload.name]: newItem
                                }
                            } else {
                                return {
                                    ...state, [action.payload.name]: [...state[action.payload.name], action.payload.value]
                                }
                            }
                        } else {
                            return {
                                ...state, [action.payload.name]: [...state[action.payload.name], action.payload.value]
                            }
                        }
                    }
                }
                else {
                    return {
                        ...state, [action.payload.name]: action.payload.value
                    };
                };
            } else {
                return {
                    ...state, [action.payload.name]: action.payload.value
                };
            }
        case "SET_ALL_ITEMS":
            return action.payload.newState;

        case "REMOVE_FROM_STATE":
            return {
                ...state, [action.payload.name]: [...state[action.payload.name], action.payload.value]
            };
        case "CLEAR_ITEM":
            return {
                ...state, [action.payload.name]: []
            };
        default:
            throw new Error();
    }
};

const PropertyContextProvider = props => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <PropertyContext.Provider value={[state, dispatch]}>
            {props.children}
        </PropertyContext.Provider>
    );
};
export default PropertyContextProvider